const DisplayTypeScreenBlock = {
  HORIZONTAL: 0,
  VERTICAL: 1
}
export default DisplayTypeScreenBlock
